import React, { useState, useEffect, useRef } from 'react';
import '../assets/styles/home.scss';
import LeftContent from '../components/home/LeftContent';
import LoadingPage from '../components/loading/Home';
import { ModalProvider } from "../contexts/modalContext";
import { LoadingProvider } from "../contexts/loadingContext";
import { ToastProvider } from "../contexts/toastContext";
import Axios from 'axios';
import Error from '../components/errors/Error';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import RightContent from '../components/home/RightContent';
import moment from 'moment';
import { Colors } from '../constants';
import ct from 'countries-and-timezones';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from '../custom_hooks/useWindowDimensions';

const INITIAL_PROPS  = {
  type: null,
  match:{
    params: {
      event_id: null,
      user_path: null,
      team_path: null,
      schedule_id: null,
      question_id: null
    }
  }
};

const Home = (props) => {
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isLoadingTiming, setIsLoadingTiming ] = useState(false);
  const [ loadingTimingPercentage, setLoadingTimingPercentage ] = useState(15);

  const [ isError, setIsError ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState(null);

  const [ color, setColor ] = useState(`#${Colors.primaryColor}`);
  const [ data, setData ] = useState({});
  const dataRef = useRef({});

  const [ isReschedule, setIsReschedule ] = useState(false);
  const [ isCancelMeeting, setIsCancelMeeting ] = useState(false);
  const [ isConfirm, setIsConfirm ] = useState(false);

  const [ path, setPath ] = useState(null);
  const [ timingPath, setTimingPath ] = useState(null);
  const [ timingsData, setTimingsData ] = useState([]);
  const [ propValues, setPropValues ] = useState(INITIAL_PROPS);
  const [ timezoneName, setTimezoneName ] = useState(null);
  const [ countryCode, setCountryCode ] = useState('us');
  const [ currentDuration, setCurrentDuration ] = useState();
  const [ scheduleLocation, setScheduleLocation ] = useState();
  
  const [ dateSelected, setDateSelected ] = useState(null);
  const [ timingSelected, setTimingSelected ] = useState(null);
  const [ showTimingSelected, setShowTimingSelected ] = useState(false);
  const [ shareTimings, setShareTimings ] = useState({}); // mutliple date and time to share

  const [ showTimingList, setShowTimingList ] = useState(false);
  const [ showForm, setShowForm ] = useState(false);

  const backButtonRef = useRef();

  const { i18n } = useTranslation();
  const [ languageCode, setLanguageCode ] = useState('en');  
  
  const [ isShareDateTime, setShareDateTime ] = useState(false);
  const URL_PARAMS = new URLSearchParams(window.location.search);
  const [ datesSelected, setDatesSelected ] = useState(0);
  const [ timeSlots, setTimeSlots ] = useState(0);
  
  const [ showButtonConfirm, setShowButtonConfirm ] = useState(false);
  const { width } = useWindowDimensions();
  const [ duration, setDuration ] = useState('');

  useEffect(() => {
    if (URL_PARAMS) {
      if (URL_PARAMS.get('share_date_time') === 'true') {
        setShareDateTime(true);
      } else if (URL_PARAMS.get('duration')) {
        setDuration(`&duration=${URL_PARAMS.get('duration')}`);
      }
    }
  },
  // eslint-disable-next-line
  []);

  // set props
  useEffect(() => {
    setPropValues(props);
  }, [props]);


  // get data
  useEffect(() => {
    const { user_path, team_path } = propValues.match.params;
     
    if(propValues.type==="schedule" || propValues.type==="event"){
      if (propValues.type==="schedule") {
        setPath(`${process.env.REACT_APP_BACKEND_URL}/api/internal/v1/scheduling/${propValues.match.params.event_id}?locale=${languageCode}`);
        setTimingPath(`${process.env.REACT_APP_BACKEND_URL}/api/internal/v1/scheduling/get_timings?event_id=${propValues.match.params.event_id}&locale=${languageCode}${duration}`);
      }
      else {
        let timesync_type_path = (user_path && `user_path=${user_path}`) ||  (team_path && `team_path=${team_path}`) || ((window.location.hostname !== process.env.REACT_APP_BASE_URL) && `custom_domain=${window.location.hostname}`)
         setPath(`${process.env.REACT_APP_BACKEND_URL}/api/internal/v1/scheduling/${propValues.match.params.event_id}?${timesync_type_path}&locale=${languageCode}`);
        // setTimingPath(`${process.env.REACT_APP_BACKEND_URL}/api/internal/v1/scheduling/get_timings?event_id=${propValues.match.params.event_id}&${timesync_type_path}`);
      }
    }
    else if(propValues.type==="question"){
      setPath(`${process.env.REACT_APP_BACKEND_URL}/api/internal/v1/scheduling/${propValues.match.params.event_id}?option_id=${propValues.match.params.question_id}&locale=${languageCode}`);
      // setTimingPath(`${process.env.REACT_APP_BACKEND_URL}/api/internal/v1/scheduling/get_timings?event_id=${propValues.match.params.event_id}&option_id=${propValues.match.params.question_id}`);
    }
    else if(propValues.type==="reschedule"){
      setIsReschedule(true);
      setPath(`${process.env.REACT_APP_BACKEND_URL}/api/internal/v1/scheduling/edit/${propValues.match.params.schedule_id}?locale=${languageCode}`);
      setTimingPath(`${process.env.REACT_APP_BACKEND_URL}/api/internal/v1/scheduling/get_timings?schedule_id=${propValues.match.params.schedule_id}&locale=${languageCode}${duration}`);
    }
  }, 
  [propValues, languageCode, duration]);

  // get data
  useEffect(() => {
    try{
      async function getData(){
        setIsLoading(true);
        await Axios.get(path)
          .then((response)=>{
            let response_data = response.data;

            if(response_data.status === 'success'){
              // Set up facebook pixel
              if (response_data.data['facebook_pixel'] != null){
                const options = {
                  autoConfig: true, // set pixel's autoConfig
                  debug: false, // enable logs
                };
                ReactPixel.init(response_data.data['facebook_pixel'], {}, options);
                ReactPixel.pageView();
              }
              // Set up google analytics
              if (response_data.data['google_analytics'] != null){
                ReactGA.initialize(response_data.data['google_analytics']);
                ReactGA.pageview(window.location.pathname + window.location.search);
              }
              if (response_data.data['google_analytics4'] != null){
                ReactGA4.initialize(response_data.data['google_analytics4']);
                ReactGA4.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
              }

              setData(response_data.data);
              dataRef.current = response_data.data;
              if (!isShareDateTime) setColor(`#${response_data.data.color}`);
              else setColor(`#${Colors.primaryColor}`)

              // get timings for booking page through qualification
              if(response_data.data.question && response_data.data.question.action_type === 'booking_page'){
                setTimingPath(`${process.env.REACT_APP_BACKEND_URL}/api/internal/v1/scheduling/get_timings?event_id=${propValues.match.params.event_id}&option_id=${propValues.match.params.question_id}&locale=${languageCode}${duration}`);
              }

              if(propValues.type === 'event' && response_data.data.question === null){
                const { user_path, team_path } = propValues.match.params;
                let timesync_type_path = (user_path && `user_path=${user_path}`) ||  (team_path && `team_path=${team_path}`) || ((window.location.hostname !== process.env.REACT_APP_BASE_URL) && `custom_domain=${window.location.hostname}`)
                setTimingPath(`${process.env.REACT_APP_BACKEND_URL}/api/internal/v1/scheduling/get_timings?event_id=${propValues.match.params.event_id}&${timesync_type_path}&locale=${languageCode}${duration}`);
              }

              setTimezoneName(response_data.data.timezone);
              getBrowserTimezone();
            }
            else{
              setErrorMessage(response_data.message)
            }
            setIsLoading(false);

          })
          .catch((error) => {
            if(error && error.response){
              if(error.response.data && error.response.data.error === 'Invalid'){
                setErrorMessage('The page you are looking for could not be found');
              }
              else{
                setErrorMessage(error.response.data.error || error.response.data.message);
              }
            }
            else{
              setErrorMessage('Error found.')
            }
            setIsLoading(false);
          })
      }

      if(path)
        getData();
    }
    catch(error){
      setErrorMessage(error.message)
    }
  }, 
  // eslint-disable-next-line
  [path]);

  // get timings
  useEffect(() => {
    if(timingPath){
      setIsLoadingTiming(true);
      getTimings();
    }
  }, 
  // eslint-disable-next-line
  [timingPath]);

  // set loading timing percentage
  useEffect(() => {
    if(isLoadingTiming){
      setLoadingTimingPercentage(15);
    }
  }, 
  // eslint-disable-next-line
  [isLoadingTiming]);

  useEffect(() => {
    if(loadingTimingPercentage >= 100){
      // then hide the progress bar (after 1 sec)
      setTimeout(() => {
        setIsLoadingTiming(false);
      }, 1000);
    } else {
      setTimeout(() => {
        if (loadingTimingPercentage < 90 && isLoadingTiming) {
          setLoadingTimingPercentage(loadingTimingPercentage+10);
        }
      }, 300);
    }
  }, [isLoadingTiming, loadingTimingPercentage]);

  // set error
  useEffect(() => {
    if(errorMessage){
      setIsError(true)
    }
    else setIsError(false);
  }, [errorMessage]);

  // set country code after set timezone
  useEffect(() => {
    if(timezoneName){
      let timezone  = ct.getTimezone(timezoneName);
      if(timezone.country){
        setCountryCode(timezone.country.toLowerCase())
      }
    }
  },
  [timezoneName]);

  // change is cancel meeting
  useEffect(() => {
    // handleTimingSelected(null);
  }, 
  // eslint-disable-next-line
  [isCancelMeeting]);
  
  // set language code
  useEffect(() => {
    if(data) {
      if(data.language_code){
        setLanguageCode(data.language_code)
      }
      else {
        setLanguageCode(navigator.language.split("-", 1).toString() || 'en');
      }
    }
  },
  // eslint-disable-next-line
  [data]);

  // change language
  useEffect(() => {
    if(languageCode){
      i18n.changeLanguage(languageCode);
    }
  }, 
  // eslint-disable-next-line
  [languageCode]);

  // callback to handle confirm button
  const handleConfirmButton = (flag = null) =>{
    if(flag === null) setShowButtonConfirm(!showButtonConfirm);
    else setShowButtonConfirm(flag);
  };

  // update current timing if reschedule
  const updateCurrentTiming = (time) => {
    if(isReschedule){
      let current_data = { ...data }
      let current_timing = data['current_timing'];
      if(current_timing){
        current_data['current_timing'] = time;
      }
      setData(current_data);
    }
  };

  const getBrowserTimezone = () => {
    // set to current timezone from moment
    setTimezoneName(moment.tz.guess());

    // // get browser timezone
    // Axios.get('https://ipapi.co/json/')
    //   .then((response) => {
    //     let data = response.data;
    //     setTimezoneName(data.timezone);
    //     setCountryCode(data.country.toLowerCase());
    //   })
    //   .catch((error) => {
    //     setErrorMessage(error.errorMessage);
    // });
  };

  const cancelMeeting = (isCancel = null, isReschedule = null) => {
    if(isCancel === null){
      setIsCancelMeeting(true);
    }
    else{
      setIsCancelMeeting(isCancel);
    }

    if(isReschedule === null){
      setIsReschedule(false);
    }
    else{
      setIsReschedule(isReschedule);
    }

    setTimingSelected(null);
  };

  // callback function to hide cancel meeting button -> after confirmation submitted
  const handleCancelMeetingButton = (flag = null) => {
    if(flag === null || flag === false)
      setIsConfirm(true); // hide button cancel
    else if(flag === true)
      setIsConfirm(false); // show button cancel
  }

  const getCurrentDate = () => { // return yyyy-mm-dd
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    return (yyyy + '-' + mm + '-' + dd);
  };
  

  // get timings
  const getTimings = (start_date = '') => {
    let current_date = getCurrentDate(); // return yyyy-mm-dd
    let timing_key = '';
    let timingsCopy = Object.assign({}, timingsData);
    
    // get current data for timings
    if(start_date.length === 0){
        let split_current_date = current_date.split("-");
        timing_key = split_current_date.slice(0, (split_current_date.length-1)).join("-");
        // set start date
        start_date = current_date;
    }
    else{
        let split_start_date = start_date.split('-');
        timing_key = split_start_date.slice(0, (split_start_date.length-1)).join("-");
    }

    Axios.get(`${timingPath}&start_date=${start_date}`)
      .then((response) => {
        timingsCopy[timing_key] = response.data.data.timings;
        // timingsCopy[timing_key] = [];
        // let timings_response = response.data.data.timings;
        // if(timings_response.length > 0){
        //   timings_response.map((timing) => timingsCopy[timing_key].push(new Date(timing)) );
        // }
        // console.log('timingsCopy', timingsCopy)

        // set the timings and set the progress bar to 100
        setTimingsData(timingsCopy);
        setCurrentDuration(response.data.data?.current_duration);
        setScheduleLocation(response.data.data?.current_location);
        dataRef.current = Object.assign(dataRef.current, { default_elements: response.data.data.default_elements, form_elements: response.data.data.form_elements, current_duration: response.data.data?.current_duration })
        setData(Object.assign(dataRef.current, { default_elements: response.data.data.default_elements, form_elements: response.data.data.form_elements, current_duration: response.data.data?.current_duration }))
        setLoadingTimingPercentage(100);
    }).catch((error) => {
      setErrorMessage(error.message);
    });
    
  };

  // callback to load new timings based on new start date
  const setNewTimingPath = (start_date) => {
    setIsLoadingTiming(true);
    setLoadingTimingPercentage(15);
    getTimings(start_date);
  };

  const setBackToReschedule = () => {
    setIsCancelMeeting(false);
  };

  // callback function to remove the timeslot from timings data
  const removeTimeslot = (timingKey, time) => {
    let timings_data = { ...timingsData };
    let timings = timings_data[timingKey].filter( timing => timing !== time);
    timings_data[timingKey] = timings;

    // if reschedule then add back the current timings to timing
    let current_timing = data['current_timing'];
    if(isReschedule && current_timing){
      let current_timing_key = moment(current_timing).tz(timezoneName).format('YYYY-MM');
      // check if timingsData has the key
      if(timings_data[current_timing_key]){
        // add
        timings_data[current_timing_key].push(current_timing);
        timings_data[current_timing_key] = timings_data[current_timing_key].sort(function(a, b) {
          return a - b; // sort ascending
        });
      }

      // update data for current timing
      updateCurrentTiming(time);
    }
    setTimingsData(timings_data);
  };

  // callback function to change the timezone and timezone name
  const handleChangeTimezone = (timezoneName) => {
    // setTimezone(timezone);
    setTimezoneName(timezoneName);
  };

  // callback function to update timing selected
  const handleTimingSelected = (timing = null) => {
    if (!isShareDateTime) {
      setTimingSelected(timing);
    }
    else {
      var current_date_time = new Date(timing);
      var key = `${current_date_time.getDate()}-${("0" + (current_date_time.getMonth() + 1)).slice(-2)}-${current_date_time.getFullYear()}`;

      if (Object.keys(shareTimings).length < 7 || Object.keys(shareTimings).includes(key)) {
        
        var timings = shareTimings || {};
        if (timings && timings[key]) {
          if (!timings[key].includes(timing)) {
            timings[key].push(timing);
          } else {
            // remove timing
            timings[key] = timings[key].filter((val) =>  val !== timing)
            if (timings[key].length === 0) {
              delete timings[key];
            }
          }
        }
        else {
          timings[key] = [timing];
        }
        // setTimingSelected(timings);
        countDaysAndTimeSlots(timings);
        setShareTimings(timings);
      }
    }
  };

  // callback to check date selected
  const checkDateSelected = (dateSelected) => {
    if(dateSelected){
      var current_date_time = new Date(dateSelected);
      var key = `${current_date_time.getDate()}-${("0" + (current_date_time.getMonth() + 1)).slice(-2)}-${current_date_time.getFullYear()}`;
      if (!isShareDateTime || (Object.keys(shareTimings).length < 7 || Object.keys(shareTimings).includes(key))) {
        if(width >= 850) {
          handleShowTimingList(true);
        }
        else {
          handleConfirmButton(true);
        }
      }
    }
  };

  // callback to count days and time slots selected
  const countDaysAndTimeSlots = (timings) => {
    setDatesSelected(Object.keys(timings).length);
    let timings_selected = [].concat.apply([], Object.values(timings));
    setTimeSlots(timings_selected.length)
  };

  // callback function to set day clicked
  const handleDateSelected = (date = null) => {
    setDateSelected(date);
    checkDateSelected(date);
  };

  // callback function to show timing selected text
  const handleShowTimingSelected = (flag = null) => {
    if(flag !== null) setShowTimingSelected(flag);
    else setShowTimingSelected(!showTimingSelected);
  };

  // for left component back button
  const backButtonOnClick = () => {
    if(backButtonRef.current) backButtonRef.current.backOnClick();
    else return false;
  };

  // to show/hide timing list
  const handleShowTimingList = (flag = null) => {
    if(flag === null) setShowTimingList(!showTimingList);
    else setShowTimingList(flag)
  };

  // to show/hide form field input
  const handleShowForm = (flag = null) => {
    if(flag === null) setShowForm(!showForm);
    else setShowForm(flag);
  };

  // change path
  const handleChangePath = (path) => {
    window.location.href = path;
  };

  if(!isShareDateTime && isLoading) return <LoadingPage />;
  if(isError) return <Error  errorMessage={errorMessage} />
  if (Object.keys(data).length > 0) {
    return(
      <ModalProvider>
        <LoadingProvider>
            <ToastProvider>
              <div className="home-timesync">
                <div className={`container ${isShareDateTime ? 'share-date-time' : ''}`}>
                  <LeftContent
                    color={color}
                    name={data['name']}
                    title={data['title']}
                    description={data['description']}
                    location={data['location'] === 'Ask Invitee' ? null : data['location']}
                    imageUrl={data['image']}
                    isReschedule={isReschedule}
                    isConfirm={isConfirm}
                    timeInterval={data['time_interval']}
                    timingSelected={timingSelected}
                    timezoneName={timezoneName}
                    isQualification={data['current_page']==="question" && data['question']['action_type']==="question"}
                    showTimingSelected={showTimingSelected}
                    backButtonOnClick={backButtonOnClick}
                    isCancelMeeting={isCancelMeeting}
                    showTimingList={showTimingList}
                    showForm={showForm}
                    locationSearch={propValues.location.search}
                    isoTime={data['iso_time']}
                    currentTiming={data['current_timing']}
                    dateSelected={dateSelected}
                    isShareDateTime={isShareDateTime}
                    durationOptions={data['duration_options']}
                    handleChangePath={handleChangePath}
                    currentDuration={data['current_duration']} />

                  <RightContent
                    ref={backButtonRef}
                    title={data['title']}
                    location={data['location'] === 'Ask Invitee' ? null : data['location']}
                    timeInterval={data['time_interval']}
                    isLoadingTiming={isLoadingTiming}
                    loadingTimingPercentage={loadingTimingPercentage}
                    color={color}
                    data={data}
                    timezoneName={timezoneName}
                    countryCode={countryCode}
                    isReschedule={isReschedule}
                    timingsData={timingsData}
                    type={propValues.type}
                    locationSearch={propValues.location.search}
                    meetingId={propValues.match.params.event_id}
                    userTeamPathId={(window.location.hostname !== process.env.REACT_APP_BASE_URL) ? '' : (data['path']['user_path'] || data['path']['team_path'])}
                    typeUser = {data['path']['user_path'] ? 'user' : 'team'}
                    isCancelMeeting={isCancelMeeting}
                    setBackToReschedule={setBackToReschedule}
                    timingPath={timingPath}
                    setNewTimingPath={setNewTimingPath}
                    removeBranding={data['remove_branding']}
                    removeTimeslot={removeTimeslot}
                    handleChangeTimezone={handleChangeTimezone}
                    handleCancelMeetingButton={handleCancelMeetingButton}
                    dateSelected={dateSelected}
                    handleDateSelected={handleDateSelected}
                    timingSelected={timingSelected}
                    handleTimingSelected={handleTimingSelected}
                    handleShowTimingSelected={handleShowTimingSelected}
                    cancelMeeting={cancelMeeting}
                    isConfirm={isConfirm}
                    showTimingList={showTimingList}
                    handleShowTimingList={handleShowTimingList}
                    showForm={showForm}
                    handleShowForm={handleShowForm}
                    languageCode={languageCode}
                    locationOptions={data['location_options']}
                    isShareDateTime={isShareDateTime}
                    shareTimings={shareTimings}
                    datesSelected={datesSelected}
                    timeSlots={timeSlots}
                    showButtonConfirm={showButtonConfirm}
                    handleConfirmButton={handleConfirmButton}
                    isoTime={data['iso_time']}
                    meetingLinkPath={data['meeting_link_path']}
                    currentDuration={currentDuration}
                    scheduleLocation={scheduleLocation} />
                </div>
              </div>
            </ToastProvider>
        </LoadingProvider>
      </ModalProvider>
    );
  }
  return null;
};

export default Home;